import React, { FC, ReactNode } from 'react';

import DataFormat from '../../format/DataFormat';
import Checkbox, { CheckboxProps } from '../Checkbox';

import { StyledLabel, StyledCheckboxWrapper, StyledLabelText } from './CheckboxItem.styles';

export interface CheckboxItemProps extends CheckboxProps {
  /** The name of the checkbox item */
  name?: string;
  /** The label to display next to the checkbox */
  label?: ReactNode;
  /** @ignore */
  readOnly?: boolean;
  /** @ignore */
  textOnly?: boolean;
  /** @ignore */
  horizontal?: boolean;
  /** @ignore */
  noBox?: boolean;
  /** @ignore */
  'data-testid'?: string;
}

export interface CheckboxItemStatics {
  StyledLabel: typeof StyledLabel;
}

const CheckboxItemDefaultProps: Partial<CheckboxItemProps> = {
  'data-testid': 'CheckboxItem',
};

/**
 * @mode developer
 */
const CheckboxItem: FC<CheckboxItemProps> & CheckboxItemStatics = ({
  label, disabled, horizontal, 'data-testid': testid, noBox, name, readOnly, textOnly, checked, ...props
}) => {
  if (textOnly) {
    const selectedLabel = checked ? label : '';
    return <DataFormat>{selectedLabel}</DataFormat>;
  }

  return (
    <StyledLabel
      disabled={disabled}
      readOnly={readOnly}
      data-testid={testid}
      data-test-name={name}
      horizontal={horizontal}
      noBox={noBox}
    >
      <StyledCheckboxWrapper>
        <Checkbox
          {...props}
          name={name}
          disabled={disabled}
          readOnly={readOnly}
          checked={checked}
        />
      </StyledCheckboxWrapper>
      <StyledLabelText horizontal={horizontal}>{label}</StyledLabelText>
    </StyledLabel>
  );
};

CheckboxItem.defaultProps = CheckboxItemDefaultProps;
CheckboxItem.StyledLabel = StyledLabel;

export default CheckboxItem;
